// extracted by mini-css-extract-plugin
export var switcher = "G_b2";
export var switcherItem = "G_b3";
export var switcherItemActive = "G_b4";